export const CONTENT_TYPE = {
	PRICING: 'pricing',
	REPRICING: 'repricing',
	DIGITAL_SHELF: 'digitalShelf',
	CATALOGUE: 'catalogue',
	MARKETPLACES: 'marketplaces',
	STOCK: 'stock',
	STOCK_CHANGES: 'stock_changes',
	STOCK_AND_ASSORTMENT: 'stock_and_assortment',
	PRICING_OVERVIEW: 'pricing_overview',
	PRICING_CHANGES: 'pricing_changes',
	MARKET_ANALYZER: 'market_analyzer',
	BASIC_FUNCTIONS: 'basic_functions',
	CATALOGUE_DETAILS: 'catalogue_details',
	CATALOGUE_ANALYZER: 'catalogue_analyzer',
}

export const CONTENT_TEXT = {
	PRICING: 'The Pricing dashboard analyzes price and discounting for a specific scope of your own products and competition. Monitor trends in all points of sale of your distribution, including direct channel, retailer and marketplaces sellers. From general data to SKU level.',
	REPRICING: 'The repricing automation system offers price recommendations based on market input and your own criteria. A joint alert systems keeps you up to speed with market price trends in real time.',
	DIGITAL_SHELF: 'Keep an eye on the quality of your product pages: number of images, product description, price, availability, ratings and reviews, etc. Ensure the best visibility through the analysis of brand advertising and product search results.',
	CATALOGUE: 'Catalog & Distribution solutions allow you to monitor key retailers that sell your products, control your brand\'s presence in different points of sale and carry out a comparative analysis with your competitors\' offering. ',
	MARKETPLACES: 'This dashboard is specifically designed to cover the marketplace business model, monitor all sellers in a marketplace to identify key vendors and outliers.',
	BASIC_FUNCTIONS: 'Learn how to use basic functions simply and effectively.',
}